import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const ApproveApplicantModal = ({ open, onClose, onApprove, applicant }) => {
  const [loading, setLoading] = useState(false);

  if (!applicant) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Aprobar Solicitud</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          ¿Estás seguro que deseas aprobar la solicitud de:
        </Typography>
        <Typography variant="h6" color="primary">
          {applicant.nombre} {applicant.apellido}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={async () => {
            setLoading(true);
            try {
              await onApprove(applicant);
            } finally {
              setLoading(false);
            }
          }}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Cargando..." : "Confirmar Aprobación"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveApplicantModal;